import React from 'react';

const StatsCards = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 mb-8">
      <div className="bg-white overflow-hidden shadow rounded-lg border-l-4 border-blue-500">
        <div className="p-5">
          <div className="flex items-baseline justify-between">
            <dt className="text-sm font-medium text-gray-500 truncate">
              Total Subscriptions
            </dt>
            <dd className="text-right">
              <div className="text-2xl font-medium text-gray-900">
                {stats.totalSubscriptions || stats.total || 0}
              </div>
            </dd>
          </div>
        </div>
      </div>
      <div className="bg-white overflow-hidden shadow rounded-lg border-l-4 border-green-500">
        <div className="p-5">
          <div className="flex items-baseline justify-between">
            <dt className="text-sm font-medium text-gray-500 truncate">
              Active Subscriptions
            </dt>
            <dd className="text-right">
              <div className="text-2xl font-medium text-gray-900">
                {stats.activeSubscriptions || stats.active || 0}
              </div>
            </dd>
          </div>
        </div>
      </div>
      <div className="bg-white overflow-hidden shadow rounded-lg border-l-4 border-orange-500">
        <div className="p-5">
          <div className="flex items-baseline justify-between">
            <dt className="text-sm font-medium text-gray-500 truncate">
              Expiring Soon
            </dt>
            <dd className="text-right">
              <div className="text-2xl font-medium text-gray-900">
                {stats.expiringSubscriptions || stats.expiring || 0}
              </div>
            </dd>
          </div>
        </div>
      </div>
      <div className="bg-white overflow-hidden shadow rounded-lg border-l-4 border-purple-500">
        <div className="p-5">
          <div className="flex items-baseline justify-between">
            <dt className="text-sm font-medium text-gray-500 truncate">
              Total Revenue
            </dt>
            <dd className="text-right">
              <div className="text-2xl font-medium text-gray-900">
                GH₵{Number(stats.totalRevenue || stats.revenue || 0).toFixed(2)}
              </div>
            </dd>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsCards;